import Vue from 'vue';
//    ┏┓   ┏┓
//  ┏┛┻━━┛┻┓
//  ┃          ┃
//  ┃   ━     ┃
//  ┃ ┳┛ ┗┳ ┃
//  ┃          ┃
//  ┃   ┻     ┃
//  ┃          ┃
//  ┗━┓   ┏━┛
//     ┃   ┃
//     ┃   ┃
//     ┃   ┗━━━┓
//     ┃         ┣┓
//     ┃          ┏┛
//     ┗┓┓┏━┳┓┏┛
//       ┃┫┫ ┃┫┫
//       ┗┻┛ ┗┻┛
// Codes are far away from bugs with the animal protecting
// 神兽保佑,代码无bug
import CommentListService from '@/hotelcem/apis/comment/commentListService'
import CommentAnalysisService from '@/hotelcem/apis/comment/commentAnalysis'
import AssessmentIndicatorsService from '@hotelcem/apis/configuration-center/assessmentIndicatorsService.js'
import router from '@/hotelcem/router'
import { CommentTypeMapping, REPLY_STATUS_ENUM } from '@/constants/comment/constants'
import { Message } from 'element-ui'
import dayjs from 'dayjs'
import TranslateService from '@/hotelcem/apis/common/TranslateService'

const workorderSession = VocSessionStorage.getWrokorderSession()
import ChannelConfig from '@/constants/channelConfig'
import { commentTreeFormatter, getSameIndicators } from '@/utils/comment/comment-functinos'
import axios from 'axios'

    import MAPI_SERVICE_ACTION_RECORD from '@m/apis/action-record/index'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

let translateCancel

const featureMap = {
  homeCriticism: 1,
  moreNegative: 2,
  emptyReview: 3,
  foldCritique: 4,
  effectiveReview: 5,
  postConsumptionComment: 6,
  delete: 7,
  noPoint: 8, // EBK不计分
}

const defaultState = {
  // AI回复
  AIReplyDialog: {
    opened: false,
    running: false,
    loading: false,
    replyTemplateList: [],
    selectedTemplate: undefined, // 选中的模板
    page: {
      current: 1,
      pageSize: 10,
    },
    originContent: '', // 点评原文
    isOpenAI: false, // 是否打开AI生成回复
    isQuickReply: false, // 快捷回复
    analysisTaskId: undefined, // 任务id
    translateStatus: undefined,
    translateResult: '', // 翻译结果
    translateTaskId: undefined, // 翻译任务id
    cachedInfo: {}, // 缓存信息
    dataItem: {}, // 当前数据
  },
  // 批量回复开关
  batchReply: {
    loading: false,
    opened: false,
    selectedList: [],
  },
  // 回复框
  replyDialog: {
    type: 'Single', // BatchReply, Single
    canEdit: true,
    opened: false,
    loading: false,
    replyTemplateList: [],
    selectedTemplate: undefined, // 选中的模板
    page: {
      current: 1,
      pageSize: 10,
    },
    dataItem: {}, // 当前数据
  },
  // 回复确认框
  replyConfirmDialog: {
    opened: false,
    unCheckTagList: [],
    replyPayload: undefined,
  },
  // 回复模板删除确认框
  replyTemplateDeleteConfirmDialog: {
    opened: false,
    selectItem: undefined,
  },
  // 纠错弹框
  errorCorrection: {
    loading: false,
    opened: false,
    rowDataItem: undefined,
    tagList: [
      {
        label: $t('e0a785'),
        children: [
          // {
          //   label: '情感有误',
          // },
          // {
          //   label: '标签有误',
          // },
          {
            label: $t('2b28b4'),
          },
          {
            label: $t('dd34ed'),
          },
        ],
      },
      {
        label: $t('2c95cb'),
        children: [],
      },
      {
        label: $t('cd9bd4'),
        children: [
          {
            label: $t('b7d4ac'),
          },
          // {
          //   label: '用户追评',
          // },
          {
            label: $t('a2331b'),
          },
          {
            label: $t('cc4fee'),
          },
        ],
      },
      {
        label: $t('6b2b97'),
        children: [
          {
            label: $t('8a8740'),
          },
          {
            label: $t('c083d1'),
          },
        ],
      },
    ],
  },
  // 评论内容查询条件
  searchForm: {
    // 点评分区间
    score: {
      min: undefined,
      max: undefined,
    },
    // 好评,中评,差评
    labelCate: undefined, // positive, neutral, bad
    // 好评,中评,差评,自定义
    commentType: undefined, // positive, neutral, bad, custom
    // 情感
    emotion: undefined,
    // 回复状态
    replyStatus: [],
    // 点评特征
    commentSpecial: ['effectiveReview'], // 默认有效点评 // 1首页差评 2负面情感较多 3空点评4折叠点评5有效点评6消费后点评
    // 反馈状态
    feedbackStatus: undefined,
    travelPurpose: undefined,
    commentArea: undefined,
    // 渠道
    channel: undefined,
    // 部门
    department: undefined,
    // 关键词
    keywords: '',
    // 语种
    languageList: [],
    // 预警等级
    alertLevels: [],
    // 是否带图
    image: undefined,
    // 优质点评
    highQualityReviews: [],
    // 标签
    leafNodeIds: [],
    // 前N条
    topN: undefined,
    valid: window.location.href.includes('valid=2') ? 2 : 1,
  },

  // 页码
  page: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
  // 部门
  department: {
    departmentLables: [],
    dataList: [],
    loading: false,
  },
  // 接口返回数据 START
  commentBadTotal: {
    loading: true,
    badTotal: 0,
    noReply: 0,
  },
  commentLabelsTree: {
    loading: false,
    selectedTree: [],
  },
  commentRawData: {
    loading: false,
  },
  channelConfig: {
    loading: false,
    channelList: [],
  },
  workOrderMappping: {},
  // 接口返回数据 END
  // 是否查询自己酒店评价
  isSelf: true,
  competitorList: [],
  currentCompetitor: '',
  isHasVIPCardPermission: false, // 是否有会员卡号权限
  vipCardNoMap: {},
  commentDataSyncTime: '', // 最新数据同步时间
  qualityShowData: {}, // 是否质检
  feedbackRecordDatas: [],
  commentIdComplaint: {},
  commentReplyStatus: [], // 是否设置过逾期渠道
  commentRuleType: true, // 默认情感：true
  commentRuleMap: {},
  isAllSelectChannel: false,
  cancelUrlToken: {},
  sentencesHighlight: false, // 点评管理-句片高亮
  urlCommentHotelMap: {}, // 点评管理url跳转的当前酒店
  urlHotel: undefined,
  treeSentimentLevel: '', // 指标树观点类型
  queryBeginKey: '',
  totalNumber: 0,
  onlyVip: false,
  isWanda: false,
  commentAllTransferEnglish: false, // 点评管理--全部翻译英文
  currentLabelsIdList: [],
}

// 点评管理查询参数
const getCommentParams = (rootState, state, payload, rootGetters) => {
  console.log('state', state)
  console.log('payload', payload)
  const filter = rootState.common.dateFilter
  const form = state.searchForm
  const hotelId = filter.hotelInfo?.hotelInfo.ctripHotelId
  const page = state.page
  let startTs = filter?.dateRange ? filter.dateRange[0] : new Date()
  startTs.setMilliseconds(0)
  startTs = startTs.getTime()
  let endTs = filter.dateRange[1]
  endTs.setMilliseconds(999)
  endTs = endTs.getTime()

  const currentRoute = router.currentRoute.query
  let params = {
    startTs,
    endTs,
    hotelId,
    cate: form.emotion,
    dataCid: payload.commentId,
    orderType: 'desc', // desc降序  asc升序
    from: (page.current - 1) * page.pageSize, // int  从第几条记录开始
    size: page.pageSize,
    multiLabels: state.commentLabelsTree.selectedTree.filter(item => {
      return item.label_1 != $t('f9b741')
    }),
    multiLabelIds: state.currentLabelsIdList || [],
    departmentName: form?.department,
    labelCate: form.labelCate, // string 观点类型
    hotelFilter: {
      tagList: {},
      hotelIdList: [filter.hotelInfo.hotelInfo?.value || filter.hotelInfo.hotelInfo?.hotelId],
    },
    vipOnly: state.isSelf && state.isWanda ? state.onlyVip : undefined,
    valid: form.valid,
    languageList: form.languageList,
    alertLevels: rootGetters['common/showNewFn'] ? form.alertLevels : [],
    highQualityReviews: form.highQualityReviews,
    leafNodeIds: form.leafNodeIds,
    topN: form.topN,
    travelPurposes: form.travelPurpose,
    locales: form.commentArea,
    startCreatedAt: currentRoute.startCreatedAt && Number(currentRoute.startCreatedAt),
    endCreatedAt: currentRoute.endCreatedAt && Number(currentRoute.endCreatedAt),
  }
  if (payload.deptUid) {
    params.deptUid = payload.deptUid
  }

  // if (payload.queryTenantId) {
  //   params.queryTenantId = payload.queryTenantId
  // }
  if (payload.isGroup) {
    params.isGroup = payload.isGroup

    delete params.hotelFilter
    delete params.hotelId
    delete params.hotelIds
  }

  // 关键词
  if (form?.keywords) params.contents = [form.keywords]

  if (!state.commentRuleType) {
    if (form.emotion === 'positive') {
      params.minScoreContain = form.score.min
      params.maxScoreContain = form.score.max
    } else if (form.emotion === 'neutral') {
      params.minScoreContain = form.score.min
      params.maxScore = form.score.max
    } else if (form.emotion === 'bad') {
      params.minScore = form.score.min
      params.maxScore = form.score.max
    } else if (form.emotion === 'custom') {
      if (form.score.min === 0) {
        params.minScore = form.score.min
      } else {
        params.minScoreContain = form.score.min
      }

      if (form.score.max === 0) {
        params.maxScore = form.score.max
      } else {
        params.maxScoreContain = form.score.max
      }
    }
  } else {
    params.minScoreContain = form.score.min
    params.maxScoreContain = form.score.max
  }
  // if (form.commentType === 'positive') {
  //   params.minScoreContain = form.score.min
  //   params.maxScoreContain = form.score.max
  // } else if (form.commentType === 'neutral') {
  //   params.minScoreContain = form.score.min
  //   params.maxScore = form.score.max
  // } else if (form.commentType === 'bad') {
  //   params.minScoreContain = form.score.min
  //   params.maxScore = form.score.max
  // } else {
  //   params.minScoreContain = form.score.min
  //   params.maxScoreContain = form.score.max
  // }

  const commentChannelDatas = ChannelConfig.allChannelList.filter(item =>
    form.channel?.split(',').includes(item.CommentListPageConfig.formSearchValue)
  )
  if (commentChannelDatas.length > 0) params.channels = commentChannelDatas.map(item => item.value)

  // 回复状态
  // if (form.replyStatus === 'replied') {
  //   params.isReply = 1
  // } else if (form.replyStatus === 'noReply') {
  //   params.isReply = 0
  // } else if (form.replyStatus === 'lateReply') {
  //   params.isReply = 3
  // } else if (form.replyStatus === 'noLateReply') {
  //   params.isReply = 4
  // } else if (form.replyStatus === 'ReplyChecking') {
  //   params.isReply = 2
  // }
  if (typeof form?.replyStatus === 'string') {
    params.isReplyList = [REPLY_STATUS_ENUM[form.replyStatus]]
  } else {
    params.isReplyList = form.replyStatus?.map(item => REPLY_STATUS_ENUM[item]) || []
  }

  // if (form.commentSpecial === 'homeCriticism') {
  //   params.feature = 1
  // } else if (form.commentSpecial === 'moreNegative') {
  //   params.feature = 2
  // }
  //params.featureList = form.commentSpecial.map(value => featureMap[value])

  if (!params.multiLabels?.length && state.department.departmentLables?.length) {
    // dynamic indicators
    params.multiLabels = state.department.departmentLables.map(item => {
      // label_1: item.label1,
      // label_2: item.label2,
      // label_3: item.label3,

      return Object.keys(item.labelMap)
        .map((value, i) => item.labelMap[`label${i + 1}`])
        .reduce((label, currentValue, currentIndex) => {
          label[`label_${currentIndex + 1}`] = currentValue
          return label
        }, {})
    })
  }
  // 反馈状态
  //if (form?.feedbackStatus) params.feedbackStatus = Number(form.feedbackStatus)
  if (form && form.feedbackStatus && form.feedbackStatus.length > 0) {
    form.feedbackStatus = form.feedbackStatus.filter(it => it)
    params.qualityStatus = form.feedbackStatus.map(item => Number(item))
  }
  if (form && form.travelPurpose && form.travelPurpose.length > 0) {
    params.travelPurposes = form.travelPurpose.filter(it => it)
  }
  if (form && form.commentArea && form.commentArea.length > 0) {
    let arr = form.commentArea.filter(it => it)
    let newArr = []
    arr.forEach(item => {
      if (item.includes(';')) {
        newArr.push(...item.split(';'))
      } else {
        newArr.push(item)
      }
    })
    params.locales = newArr
  }

  // 是否带图
  if (form?.image) params.hasPic = form.image == 0

  return params
}

export default {
  namespaced: true,
  state: VocDeepClone.deepClone(defaultState),
  mutations: {
    SET_TREE_SENTIMENT_LEVEL(state, treeSentimentLevel) {
      state.treeSentimentLevel = treeSentimentLevel
    },
    SET_SENTENCES_HIGHLIGHT(state, sentencesHighlight) {
      console.log(this.sentencesHighlight, 'sentencesHighlight')
      state.sentencesHighlight = sentencesHighlight
    },
    SET_IS_ALL_SELECT_CHANNEL(state, isAllSelectChannel) {
      state.isAllSelectChannel = isAllSelectChannel
    },
    SET_COMMENTIDCOMPLAINT(state, commentIdComplaint) {
      state.commentIdComplaint = commentIdComplaint
    },
    SET_DEPARTMENT(state, payload) {
      state.department = { ...state.department, ...payload }
    },
    SET_CHANNEL_CONFIG(state, payload) {
      state.channelConfig = { ...state.channelConfig, ...payload }
    },
    RESET_STORE(state, payload) {
      for (const key in defaultState) {
        if (Object.hasOwnProperty.call(defaultState, key)) {
          state[key] = VocDeepClone.deepClone(defaultState[key])
        }
      }
      try {
        // const {
        //   channel,
        //   commentSpecial,
        //   commentType,
        //   emotion,
        //   replyStatus,
        //   label,
        //   labelCate,
        // } = router.currentRoute.query

        // 格式化出问题
        const currentRoute = router.currentRoute.query

        const { channel } = currentRoute
        const { commentSpecial = 'effectiveReview' } = currentRoute
        const { commentType } = currentRoute
        const { emotion } = currentRoute
        const { replyStatus } = currentRoute
        const { label } = currentRoute
        const { labelCate } = currentRoute
        const { ruleType } = currentRoute
        const { languageList } = currentRoute
        const { alertLevels } = currentRoute
        const { highQualityReviews } = currentRoute
        const { leafNodeIds } = currentRoute
        const { topN } = currentRoute
        if (ruleType) {
          state.commentRuleType = ruleType == 1
        }

        let { min, max } = CommentTypeMapping[emotion] || {}
        if (currentRoute?.min && currentRoute?.max) {
          min = Number(currentRoute.min)
          max = Number(currentRoute.max)
        }

        if (labelCate) {
          state.treeSentimentLevel = labelCate
        }

        state.searchForm = {
          channel,
          commentSpecial: commentSpecial === 'all' ? [] : [commentSpecial],
          commentType,
          emotion,
          replyStatus: replyStatus?.split(',') || [],
          languageList: languageList || [],
          alertLevels: alertLevels?.split(',') || [],
          highQualityReviews: highQualityReviews || [],
          leafNodeIds: leafNodeIds?.split(',') || [],
          topN: topN ? Number(topN) : undefined,
          labelCate,
          score: {
            min,
            max,
          },
          valid: window.location.href.includes('valid=2') ? 2 : 1,
          ...payload,
        }

        if (state.commentRuleType) {
          state.searchForm.score.min = undefined
          state.searchForm.score.max = undefined
        }

        if (label) {
          state.commentLabelsTree.selectedTree.push(JSON.parse(label))
        }
        state.urlHotel = currentRoute?.hotelId
        // 获取竞对酒店
        const competeHotelId = currentRoute?.competeHotelId
        if (competeHotelId) {
          state.currentCompetitor = competeHotelId
          state.isSelf = false
          // const defaultHotelInfo = localStorage['VOCUST_HOTEL_CEM_DEFAULT']
          // state.urlCommentHotelMap = defaultHotelInfo
          //   ? {
          //       ...JSON.parse(defaultHotelInfo),
          //       urlHotelId: currentRoute?.hotelId,
          //     }
          //   : {}
        }
      } catch (error) {
        console.error($t('a28e70') + error)
      }
    },
    SET_REPLY_CONFIRM_DIALOG(state, payload) {
      state.replyConfirmDialog = { ...state.replyConfirmDialog, ...payload }
    },
    SET_REPLY_DIALOG(state, payload) {
      state.replyDialog = { ...state.replyDialog, ...payload }
    },
    SET_AI_REPLY(state, payload) {
      state.AIReplyDialog = { ...state.AIReplyDialog, ...payload }
    },
    SET_BATCH_REPLY(state, payload) {
      state.batchReply = { ...state.batchReply, ...payload }
    },
    SET_SEARCH_FORM(state, payload) {
      state.searchForm = { ...state.searchForm, ...payload }
    },
    SET_ERROR_CORRECTION(state, payload) {
      state.errorCorrection = { ...state.errorCorrection, ...payload }
    },
    SET_DELETE_CONFIRM_DIALOG(state, payload) {
      state.replyTemplateDeleteConfirmDialog = { ...state.replyTemplateDeleteConfirmDialog, ...payload }
    },
    UPDATE_PAGER(state, payload) {
      state.page = { ...state.page, ...payload }
    },
    RESET_PAGER(state) {
      state.page = {
        current: 1,
        pageSize: 10,
      }
    },
    SET_TOTAL(state, payload) {
      state.totalNumber = payload.totalNumber
    },
    SET_COMMENT_BAD_TOTAL(state, payload) {
      state.commentBadTotal = { ...state.commentBadTotal, ...payload }
    },
    SET_COMMENT_LABELS_TREE(state, payload) {
      state.commentLabelsTree = { ...state.commentLabelsTree, ...payload }
    },
    // 用于存储初始化指标树数据
    SET_INIT_LABELS_TREE(state, initLabelsTree) {
      state.initLabelsTree = initLabelsTree
    },
    SET_COMMENT_RAW_DATA(state, payload) {
      state.commentRawData = { ...state.commentRawData, ...payload }
    },
    SET_WORKER_ORDER_MAPPING(state, payload) {
      state.workOrderMappping = { ...state.workOrderMappping, ...payload }
    },
    SET_FEEDBACK_RECORD_MAP(state, feedbackRecordDatas) {
      state.feedbackRecordDatas = feedbackRecordDatas
    },
    SET_QUALITY_SHOW_DATA(state, qualityShowData) {
      state.qualityShowData = qualityShowData
    },
    // 回复后更新状态
    UPDATE_COMMENT_RAW_DATA(state, { dataCidList, replyContent }) {
      const dataCidMap = state.commentRawData.rowData.reduce((obj, item, index) => {
        obj[item.dataCid] = index
        return obj
      }, {})
      for (const dataCid of dataCidList) {
        if (dataCidMap[dataCid] !== undefined && state.commentRawData.rowData[dataCidMap[dataCid]]) {
          Vue.set(state.commentRawData.rowData[dataCidMap[dataCid]], 'replyIngList', [
            {
              commentDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              detail: replyContent,
              status: 0,
            },
          ])
          Vue.set(state.commentRawData.rowData[dataCidMap[dataCid]], 'isFeedBack', 2)
        }
      }
    },
    SET_SELF_STATUS(state, payload) {
      state.isSelf = payload
    },
    SET_COMPETITOR_LIST(state, payload) {
      state.competitorList = payload
      if (state.currentCompetitor === '') {
        state.currentCompetitor = payload[0]?.hotelId //|| payload[0]?.queryTenantId
      }
    },
    SET_CURRENT_COMPETITOR(state, payload) {
      state.currentCompetitor = payload
    },
    SET_VIP_CARD_PERMISSION(state, isHasVIPCardPermission) {
      state.isHasVIPCardPermission = isHasVIPCardPermission
    },
    SET_VIP_CARD_MAP(state, vipCardNoMap) {
      state.vipCardNoMap = vipCardNoMap
    },
    SET_COMMENT_DATA_SYNC_TIME(state, commentDataSyncTime) {
      state.commentDataSyncTime = commentDataSyncTime
    },
    SET_COMMENT_REPLY_STATUS(state, commentReplyStatus) {
      state.commentReplyStatus = commentReplyStatus
    },
    SET_COMMENT_RULE_TYPE(state, commentRuleType) {
      state.commentRuleType = commentRuleType
    },
    SET_COMMENT_RULE_MAP(state, commentRuleMap) {
      state.commentRuleMap = commentRuleMap
    },
    SET_CANCEL_URL_TOKEN(state, payload) {
      state.cancelUrlToken = { ...state.cancelUrlToken, ...payload }
    },
    SET_URL_COMMENT_HOTELID(state, urlCommentHotelMap) {
      state.urlCommentHotelMap = urlCommentHotelMap
    },
    SET_URL_HOTEL(state, urlHotel) {
      state.urlHotel = urlHotel
    },
    SET_QUERY_BEGIN_KEY(state, queryBeginKey) {
      state.queryBeginKey = queryBeginKey
    },
    SET_ONLYVIP(state, onlyVip) {
      state.onlyVip = onlyVip
    },
    SET_ISWANDA(state, isWanda) {
      state.isWanda = isWanda
    },
    SET_CURRENT_LABELS_ID_LIST(state, currentLabelsIdList) {
      state.currentLabelsIdList = currentLabelsIdList
    },
  },
  actions: {
    // 翻译
    async translateLanguage({ commit, state }, payload = {}) {
      let tableData = state.commentRawData.rowData
      let isEnglish = payload.isEnglish
      state.commentAllTransferEnglish = payload.isEnglish

      if (isEnglish) {
        if (translateCancel) {
          translateCancel({
            code: -2000,
            message: 'The user actively cancels the request',
          })
        }
        let textList = [] // 注意了。这边不是段落是语片，所以
        for (let i = 0; i < tableData.length; i++) {
          // let codes = tableData[i].detail.codes   // 如果希望语片和句子能高亮的话则翻译语片，将语片组合成value
          // codes.map(item => {
          //   textList.push(item.linkContent)
          //   return item
          // })
          if (!tableData[i].detail.translated) {
            tableData[i].detail.bakValue = tableData[i].detail.value
            textList.push(tableData[i].detail.value)
          }
        }
        // 将txtList 尽情翻译;
        const CancelToken = axios.CancelToken
        const resContent = await TranslateService.textTranslate(
          {
            textList,
            targetLanguage: 'en',
          },
          { cancelToken: new CancelToken(e => (translateCancel = e)) }
        )
        if (!resContent?.success) {
          return
        }
        let index = 0
        for (let i = 0; i < tableData.length; i++) {
          // let codes = tableData[i].detail.codes
          // codes.map(item => {
          //   item.linkContent = resContent.data[index]
          //   item.labelContent = resContent.data[index]
          //   index++
          //   return item
          // })
          if (!tableData[i].detail.translated) {
            tableData[i].detail.value = resContent.data[index]
            index++
            tableData[i].detail.translated = true
          }
        }
        commit('SET_COMMENT_RAW_DATA', {
          ...state.commentRawData,
          rowData: tableData,
        })
      } else {
        for (let i = 0; i < tableData.length; i++) {
          tableData[i].detail.translated = false
          if (tableData[i].detail.bakValue) {
            tableData[i].detail.value = tableData[i].detail.bakValue
          }
        }
        commit('SET_COMMENT_RAW_DATA', {
          ...state.commentRawData,
          rowData: tableData,
        })
      }
    },
    // 导出
    async onCommentExport({ rootState, state, commit, dispatch, rootGetters }, payload = {}) {
      const params = await getCommentParams(rootState, state, payload, rootGetters)
      const {
        cate, // 点评情感
        labelCate, // 观点类型
      } = params

      const { x, y } = payload.e
      const opt = {
        startX: x,
        startY: y,
      }
      const dom = document.querySelector('#download_box')
      if (dom) {
        const data = dom.getBoundingClientRect()
        opt.endX = data.x
        opt.endY = data.y
      }
      let filters = {
        hotelIds: rootState.common.dateFilter.hotelInfo?.value || rootState.common.dateFilter.hotelInfo?.hotelId,
        // sentimentLevel: cate, // 点评情感
        labelSentimentLevel: labelCate, // 观点类型
        ...params,
      }
      if (!state.isSelf) {
        filters.competeHotelId =
          state?.currentCompetitor === 'all_area'
            ? state.competitorList
                .filter(item => item.hotelType === 'area')
                .map(item => item.hotelId)
                .join(',')
            : state.currentCompetitor
      }
      if (state.commentRuleType) {
        filters.sentimentLevel = cate
      }

      // 导出接口
      CommentListService.exportAnalysis(filters)
        .then(() => {
          opt.onFinished = () => {
            rootState.downloadStatus.newTask = true
          }
          payload.flydot(opt)
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 查询部门列表
    async listDepartment({ commit, dispatch, state, rootState }, payload = {}) {
      if (state.department.loading) {
        return
      }
      commit('SET_DEPARTMENT', { loading: true })
      // const hotelId = rootState.common.dateFilter?.hotelInfo?.value
      let params = {
        hotelId: rootState.common.dateFilter?.hotelInfo?.value,
      }
      if (payload.isGroup) {
        params = {
          ...payload,
        }
      }
      const res = await CommentListService.deptListByHotel({ ...params })
      if (res?.data && res?.code === 200) {
        commit('SET_DEPARTMENT', { dataList: res.data })
        const department = router.currentRoute.query.department
        if (department && res.data.find(item => item === department)) {
          await dispatch('listLablesByDepartment', { department })
        }
      }
      commit('SET_DEPARTMENT', { loading: false })
    },
    // 根据部门查询指标List
    async listLablesByDepartment({ commit, rootState }, { department }) {
      commit('SET_SEARCH_FORM', { department })
      if (!department) {
        commit('SET_DEPARTMENT', { departmentLables: [] })
        return
      }

      const hotelId = rootState.common.dateFilter?.hotelInfo?.value
      const departmentName = department
      const res = await CommentListService.getLabelsByDept({ hotelId, departmentName })
      if (res?.data && res?.code === 200) {
        const departmentLables = res.data.filter(item => Number(item.type) === 3 || Number(item.type) === 4)

        commit('SET_DEPARTMENT', { departmentLables: departmentLables })
        if (departmentLables?.length === 0) {
          return Promise.reject($t("5830b3",[departmentName]))
        }
      }
    },
    // 查询点 竞争对手 点评记录
    async listCommentRawDataForCompetitor({ rootState, state, commit, dispatch, rootGetters }, payload = {}) {
      try {
        // if (state.commentRawData.loading) {
        //   return
        // }

        // if (state.isAllSelectChannel) {
        //   commit('UPDATE_PAGER', { total: 0 })
        //   commit('SET_COMMENT_RAW_DATA', {
        //     rowData: [],
        //     rawTotal: 0,
        //   })
        // }
        // 句片高亮
        if (translateCancel) {
          translateCancel({
            code: -2000,
            message: 'The user actively cancels the request',
          })
        }
        const sententcesHighlightMap = localStorage.getItem('COMMENT_SENTENTCE_HIGHLIGHT')
        const sentencesHighlight = Reflect.has(payload, 'sentencesHighlight')
          ? payload.sentencesHighlight
          : sententcesHighlightMap
            ? JSON.parse(sententcesHighlightMap)
            : false
        state.sentencesHighlight = sentencesHighlight

        // 非默认酒店
        // if (state?.urlHotel) {
        //   const resList2 = await AuthService.getHotelList({
        //     hotelNameSearch: '',
        //     pageNo: 1,
        //     pageSize: 1,
        //     hotelIdList: [state?.urlCommentHotelMap?.urlHotelId],
        //   })
        //   if (resList2.data?.records?.length > 0) {
        //     state.urlCommentHotelMap = {
        //       hotelInfo: {
        //         hotelInfo: resList2.data.records.map(item => {
        //           return {
        //             label: item.hotelName,
        //             value: item.hotelId,
        //             ...item,
        //           }
        //         })[0],
        //       },
        //       urlHotelId: state?.urlCommentHotelMap?.urlHotelId,
        //     }
        //   }
        // }

        commit('SET_COMMENT_RAW_DATA', { loading: true })
        const form = state.searchForm
        const page = state.page
        const filter = payload.filter || rootState.common.dateFilter
        let startTs = filter?.dateRange ? filter.dateRange[0] : new Date()
        startTs.setHours(0)
        startTs.setMinutes(0)
        startTs.setSeconds(0)
        startTs.setMilliseconds(0)
        startTs = startTs.getTime()
        let endTs = filter?.dateRange ? filter.dateRange[1] : new Date()
        endTs.setHours(23)
        endTs.setMinutes(59)
        endTs.setSeconds(59)
        endTs.setMilliseconds(999)
        endTs = endTs.getTime()
        const hotelId = filter?.hotelInfo?.value || rootState.common.dateFilter?.hotelInfo?.value

        const currentRoute = router.currentRoute.query

        let params = {
          startTs,
          endTs,
          hotelIds: state.isSelf
            ? filter?.hotelInfo?.hotelInfo?.ctripHotelId
            : payload.hotelIds || state.currentCompetitor,
          // sentimentLevel: form.emotion, // 点评情感
          pageIndex: page.current, // int  从第几条记录开始
          size: page.pageSize,
          multiLabels: state.commentLabelsTree.selectedTree.filter(item => {
            return item.label_1 != $t('f9b741')
          }),
          multiLabelIds: state.currentLabelsIdList || [],
          // labelSentimentLevel: form.labelCate, // string 观点类型
          orderType: 'desc', // desc降序  asc升序
          otaCommentId: '12123456',
          hotelId: hotelId,
          departmentName: form?.department, // 部门名称
          vipOnly: state.isSelf && state.isWanda ? state.onlyVip : undefined,
          valid: form.valid,
          languageList: form.languageList,
          alertLevels: rootGetters['common/showNewFn'] ? form.alertLevels : [],
          highQualityReviews: form.highQualityReviews,
          travelPurposes: form.travelPurpose,
          locales: form.commentArea,
          startCreatedAt: currentRoute.startCreatedAt && Number(currentRoute.startCreatedAt),
          endCreatedAt: currentRoute.endCreatedAt && Number(currentRoute.endCreatedAt),
        }
        if (form.leafNodeIds && form.leafNodeIds.length > 0) {
          params.leafNodeIds = form.leafNodeIds
        }
        if (form.topN) {
          params.topN = form.topN
        }
        if (payload.viewNodeIds && payload.viewNodeIds.length > 0) {
          params.viewNodeIds = payload.viewNodeIds
        }
        if (payload.isGroup) {
          params.isGroup = payload.isGroup
          params.deptUid = payload.deptUid
          // if (payload.queryTenantId) {
          //   params.tenantId = payload.queryTenantId
          // }
        }

        // 指标树上的--观点类型
        if (form.labelCate) {
          params['labelSentimentLevel'] = form.labelCate
        }

        // 点评类型
        if (state.commentRuleType) {
          params.sentimentLevel = form.emotion
          params.minScoreContain = form.score.min
          params.maxScoreContain = form.score.max
        }
        if (!state.commentRuleType) {
          if (form.emotion === 'positive') {
            params.minScoreContain = form.score.min
            params.maxScoreContain = form.score.max
          } else if (form.emotion === 'neutral') {
            params.minScoreContain = form.score.min
            params.maxScore = form.score.max
          } else if (form.emotion === 'bad') {
            params.minScore = form.score.min
            params.maxScore = form.score.max
          } else if (form.emotion === 'custom') {
            if (form.score.min === 0) {
              params.minScore = form.score.min
            } else {
              params.minScoreContain = form.score.min
            }

            if (form.score.max === 0) {
              params.maxScore = form.score.max
            } else {
              params.maxScoreContain = form.score.max
            }
          }
        }

        // 反馈状态
        // if (form?.feedbackStatus) params.feedbackStatus = Number(form.feedbackStatus)
        if (form && form.feedbackStatus && form.feedbackStatus.length > 0) {
          form.feedbackStatus = form.feedbackStatus.filter(it => it)
          params.qualityStatus = form.feedbackStatus.map(item => Number(item))
        }
        if (form && form.travelPurpose && form.travelPurpose.length > 0) {
          params.travelPurposes = form.travelPurpose.filter(it => it)
        }
        if (form && form.commentArea && form.commentArea.length > 0) {
          // params.locales = form.commentArea.filter(it => it)
          let arr = form.commentArea.filter(it => it)
          let newArr = []
          arr.forEach(item => {
            if (item.includes(';')) {
              newArr.push(...item.split(';'))
            } else {
              newArr.push(item)
            }
          })
          params.locales = newArr
        }

        // 是否带图
        if (form?.image) params.hasPic = form.image == 0

        // 关键词
        if (form?.keywords) params.contents = [form.keywords]
        // if (form.commentType === 'positive') {
        //   params.minScoreContain = form.score.min
        //   params.maxScoreContain = form.score.max
        // } else if (form.commentType === 'neutral') {
        //   params.minScoreContain = form.score.min
        //   params.maxScore = form.score.max
        // } else if (form.commentType === 'bad') {
        //   params.minScore = form.score.min
        //   params.maxScore = form.score.max
        // } else {
        //   params.minScoreContain = form.score.min
        //   params.maxScoreContain = form.score.max
        // }

        const commentChannelDatas = ChannelConfig.allChannelList.filter(item =>
          form.channel?.split(',').includes(item.CommentListPageConfig.formSearchValue)
        )
        if (commentChannelDatas.length > 0) params.channels = commentChannelDatas.map(item => item.value)

        // 竞对酒店并且是全部的时候，传全部渠道
        if (!state.isSelf && !params.channels) {
          const values = state.channelConfig.channelList.map(item => item.formSearchValue)
          params['channels'] = ChannelConfig.allChannelList
            .filter(item => values.includes(item.CommentListPageConfig.formSearchValue))
            .map(item => item.value)
        }

        // 竞对酒店传竞对酒店id
        // const urlHotelId = state?.urlCommentHotelMap?.hotelInfo?.hotelInfo?.hotelId
        if (!state.isSelf) {
          if (payload.isGroup) {
            // params.queryTenantId = payload.queryTenantId || ''
            delete params.hotelId
            delete params.hotelFilter
            delete params.hotelIds
            // delete params.competeHotelId
          } else {
            params.hotelIds = filter?.hotelInfo?.value
          }
          params['competeHotelId'] =
            state?.currentCompetitor === 'all_area'
              ? state.competitorList
                  .filter(item => item.hotelType === 'area')
                  .map(item => item.hotelId)
                  .join(',')
              : state.currentCompetitor

          // params.hotelIds = state?.urlCommentHotelMap?.urlHotelId ? urlHotelId : filter?.hotelInfo?.value

          // if (state?.urlCommentHotelMap?.urlHotelId) {
          //   params.hotelId = urlHotelId
          // }
        }

        // if (form.replyStatus === 'replied') {
        //   params.isReply = 1
        // } else if (form.replyStatus === 'noReply') {
        //   params.isReply = 0
        // } else if (form.replyStatus === 'lateReply') {
        //   params.isReply = 3
        // } else if (form.replyStatus === 'noLateReply') {
        //   params.isReply = 4
        // } else if (form.replyStatus === 'ReplyChecking') {
        //   params.isReply = 2
        // }
        if (typeof form?.replyStatus === 'string') {
          params.isReplyList = [REPLY_STATUS_ENUM[form.replyStatus]]
        } else {
          params.isReplyList = form?.replyStatus?.map(item => REPLY_STATUS_ENUM[item]) || []
        }
        // if (form.commentSpecial === 'homeCriticism') {
        //   params.feature = 1
        // } else if (form.commentSpecial === 'moreNegative') {
        //   params.feature = 2
        // }

        // params.featureList = form.commentSpecial.map(value => featureMap[value])

        if (!params.multiLabels?.length && state.department.departmentLables?.length) {
          // dynamic indicators
          params.multiLabels = state.department.departmentLables.map(item => {
            // label_1: item.label1,
            // label_2: item.label2,
            // label_3: item.label3,
            return Object.keys(item.labelMap)
              .map((value, i) => item.labelMap[`label${i + 1}`])
              .reduce((label, currentValue, currentIndex) => {
                label[`label_${currentIndex + 1}`] = currentValue
                return label
              }, {})
          })
        }

        // if (payload.treeChange) {
        //   delete params['departmentName']
        // } else if (payload.departmentChange || (params.departmentName && params.multiLabels.length > 0)) {
        //   delete params['multiLabels']
        // }

        // 语音列表跳转过来的
        const uuiCallId = router.currentRoute?.query?.uuiCallId
        if (uuiCallId) params['uuiCallId'] = uuiCallId
        const biCommentId = router.currentRoute?.query?.biCommentId
        if (biCommentId && !rootState.common.isChangeHotel) params['ids'] = [biCommentId]
        if (!payload.isGroup) {
          params.hotelFilter = {
            tagList: {},
            // hotelIdList: state?.urlCommentHotelMap?.urlHotelId ? [urlHotelId] : [filter?.hotelInfo?.value],
            hotelIdList: [filter?.hotelInfo?.value],
          }
        }

        const channelMap = await ChannelConfig.getChannelConfigMap(filter?.hotelInfo?.value, payload)
        CommentAnalysisService.searchAnalysiaContentCount(params).then(res => {
          let totalNumber = 0

          totalNumber = res
          commit('SET_TOTAL', {
            totalNumber,
          })

          // const totalNumber = await CommentAnalysisService.searchAnalysiaContentCount(params)

          const { countMap = {} } = totalNumber.data || {}
          const convertChannelMap = {}
          ChannelConfig.allChannelList.map(item => {
            convertChannelMap[item.value] = item.CommentListPageConfig.totalBiKey
          })

          let counting = {
            allTotal: countMap?.all,
          }
          Object.keys(convertChannelMap).map(item => {
            if (countMap[item]) {
              counting[convertChannelMap[item]] = countMap[item]
            }
          })

          commit('SET_COMMENT_RAW_DATA', {
            rawTotal: totalNumber.data?.total || 0,
            counting,
          })
          if (totalNumber && totalNumber.data) {
            commit('UPDATE_PAGER', { total: totalNumber.data.total > 0 ? totalNumber.data.total : 0 })
          }
        })

        const res = await CommentAnalysisService.searchAnalysiaContent(params)
        if (res?.data && res?.code === 200) {
          let list =
            res.data.records?.length > 0
              ? res.data.records.map(item => {
                  let { extraValues, sentiment, value, hotelChannelInfoList } = item
                  let replyList = []
                  if (extraValues.replyContent) {
                    replyList = [
                      {
                        detail: extraValues.replyContent,
                        commentDate: extraValues.replyDate,
                      },
                    ]
                  }
                  const channelImg = ChannelConfig.allChannelList.filter(
                    channel => channel.value === extraValues.channel
                  )

                  let imgList = []
                  if (extraValues.extraInfo && extraValues.extraInfo.picInfoList) {
                    for (let i = 0; i < extraValues?.extraInfo?.picInfoList.length; i++) {
                      let item = extraValues?.extraInfo?.picInfoList[i]
                      const collectType = extraValues?.collectType
                      if (collectType === 'ebk') {
                        imgList.push(item.picUrl)
                      } else if (item.picUrl && !item.picUrl.includes('.mp4')) {
                        imgList.push(
                          extraValues.channel === 'ctrip'
                            ? 'https://dimg04.c-ctrip.com/images/' + item.picUrl
                            : item.picUrl
                        )
                      }
                    }
                  }

                  return {
                    rowId: item.rowId,
                    alertLevel: extraValues?.alertLevel || '',
                    extraScore: extraValues.extraScore, // 携程、艺龙、飞猪
                    channel: channelMap[extraValues.channel],
                    channel__en: extraValues.channel,
                    channelImg: channelImg.length > 0 ? channelImg[0].img : '', // 渠道Icon
                    commentDate: extraValues.commentDate,
                    commentType: extraValues.userCommentType,
                    dataCid: extraValues.dataCid,
                    createdAt: extraValues?.createdAt,
                    updatedAt: extraValues?.updatedAt,
                    userCommentBed: extraValues?.userCommentBed, // 房型
                    locale: item?.locale, // 点评来源
                    startCreatedAt: extraValues?.startCreatedAt,
                    extraInfo: extraValues?.extraInfo,
                    sentimentValue: extraValues?.sentimentValue,
                    sentimentLevel: extraValues?.sentimentLevel,
                    endCreatedAt: extraValues?.endCreatedAt,
                    collectType: extraValues?.collectType,
                    isQuality: String(item.isQuality) ? item.isQuality : 0, // 0-我要反馈  1-反馈记录
                    detail: {
                      cate: sentiment.type,
                      value,
                      codes: extraValues.cubeCommentLabelList
                        .filter(item => item.labelContent)
                        .map((it, i) => {
                          // dynamic indicators
                          Object.values(it.labelMap).map((item, i) => {
                            if (item !== 'null') it[`label_${i + 1}`] = item
                          })

                          // it.label_1 = it.label1
                          // it.label_2 = it.label2
                          // it.label_3 = it.label3
                          it.linkContent = it.labelContent

                          let levelBase64 = btoa(encodeURIComponent(it.labelSentimentLevel))
                          if (levelBase64 === 'JUU2JUFEJUEz') {
                            // btoa(encodeURIComponent('正'))
                            it.cate = 'positive'
                          } else if (levelBase64 === 'JUU0JUI4JUFE') {
                            // btoa(encodeURIComponent('中'))
                            it.cate = 'neutral'
                          } else if (levelBase64 === 'JUU4JUI0JTlG') {
                            // btoa(encodeURIComponent('负'))
                            it.cate = 'bad'
                          }
                          return it
                        }),
                      chTransText: extraValues.chTransText || '',
                      language: extraValues?.language,
                    },
                    liveDate: extraValues.userLiveDate,
                    replyList,
                    score: Number(extraValues.commentScore),
                    realScore: extraValues.commentScore,
                    isReply:
                      extraValues?.isReply == 2 || extraValues?.isReply == 0 || extraValues?.isReply == -2
                        ? extraValues.isReply
                        : replyList.length,
                    hotelName: extraValues?.hotelName,
                    preConsumer:
                      extraValues.channel === 'dianping' && extraValues?.extraInfo?.isPreConsumer === 0
                        ? $t('d5231e')
                        : '',
                    labelPortrait: extraValues.labelPortrait || [],
                    detailCommentId: extraValues?.detailCommentId,
                    qualityMap: {
                      commentId: extraValues?.commentId,
                      channel: extraValues.channel,
                      hotelId: extraValues.hotelId,
                      channelHotelID: hotelChannelInfoList[0]?.channelHotelId,
                    },
                    featureList: extraValues?.featureList,
                    cubeCommentLabelList: extraValues?.cubeCommentLabelList,
                    // 是否带图
                    imageList: imgList,
                    isCoding: extraValues.isCoding, // 0:不展示标签  1:展示标签
                    notScoredReason: extraValues?.notScoredReason, // EBK不计分
                    hotelId: payload.isGroup ? item.item || extraValues.hotelId || '' : '',

                    userInfoId: extraValues.userInfoId,
                    valid: extraValues.valid,
                    notValidReason: extraValues.notValidReason || '',
                  }
                })
              : []
          let rowDataMap = {
            ...res.data,
            // rawTotal: totalNumber.data.total, //res.data.total,
            // counting,
            rowData: list,
            sentencesHighlight,
            loading: false,
            lastRowData: list,
          }

          if (payload.append) {
            rowDataMap.rowData = state.commentRawData?.rowData?.concat(list)
            commit('SET_COMMENT_RAW_DATA', rowDataMap)
          } else {
            commit('SET_BATCH_REPLY', { selectedList: [] })
            commit('SET_COMMENT_RAW_DATA', rowDataMap)
          }

          // 我的酒店

          if (state.isSelf) {
            dispatch('fetchWorkOrderMapping')
            // 加载会员卡号信息
            dispatch('getVIPCardNoPermission').then(_ => {
              dispatch('getVIPCardNoMap', rowDataMap.rowData)
            })

            // dispatch('getIsQuality', rowDataMap)

            // 查询每个点评是否存在差评数
            // 改为只查最后一次请求的数据
            dispatch('fetchComplaintCommentCount', rowDataMap.lastRowData || [])
          }
        }

        if (res?.code === 400) {
          commit('UPDATE_PAGER', { total: 0 })
          commit('SET_COMMENT_RAW_DATA', {
            rowData: [],
            rawTotal: 0,
          })
          Message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
      commit('SET_COMMENT_RAW_DATA', { loading: false })
    },
    // 查询 竞争对手 指标树
    async listCommentLabelsTreeForCompetitor({ rootState, state, commit }, payload = {}) {
      try {
        // if (state.commentLabelsTree.loading) {
        //   return
        // }
        // if (state.isAllSelectChannel) {
        //   commit('SET_SEARCH_FORM', { department: undefined })
        //   commit('SET_COMMENT_LABELS_TREE', {
        //     labelMap: {},
        //     raws: [],
        //   })
        // }

        commit('SET_COMMENT_LABELS_TREE', { loading: true })
        const form = state.searchForm
        const filter = rootState.common.dateFilter
        let startTs = filter?.dateRange ? filter.dateRange[0] : new Date()
        startTs.setMinutes(0)
        startTs.setSeconds(0)
        startTs.setMilliseconds(0)
        startTs = startTs.getTime()
        let endTs = filter?.dateRange ? filter.dateRange[1] : new Date()
        endTs.setHours(23)
        endTs.setMinutes(59)
        endTs.setSeconds(59)
        endTs.setMilliseconds(999)
        endTs = endTs.getTime()
        const currentRoute = router.currentRoute.query
        const params = {
          startTs,
          endTs,
          hotelIds: state.isSelf
            ? filter.hotelInfo?.hotelInfo.ctripHotelId
            : payload.hotelIds || state.currentCompetitor,
          // labelSentimentLevel: form.labelCate, // string 观点类型
          // sentimentLevel: form.emotion, //点评情感

          departmentName: form?.department, // 部门名称
          startCreatedAt: currentRoute.startCreatedAt && Number(currentRoute.startCreatedAt),
          endCreatedAt: currentRoute.endCreatedAt && Number(currentRoute.endCreatedAt),
          ...payload,
        }
        // 点评类型
        // if (state.commentRuleType) {
        //   params.sentimentLevel = form.emotion
        //   params.minScoreContain = form.score.min
        //   params.maxScoreContain = form.score.max
        // }

        // if (!state.commentRuleType) {
        //   if (form.emotion === 'positive') {
        //     params.minScoreContain = form.score.min
        //     params.maxScoreContain = form.score.max
        //   } else if (form.emotion === 'neutral') {
        //     params.minScoreContain = form.score.min
        //     params.maxScore = form.score.max
        //   } else if (form.emotion === 'bad') {
        //     params.minScore = form.score.min
        //     params.maxScore = form.score.max
        //   } else if (form.emotion === 'custom') {
        //     if (form.score.min === 0) {
        //       params.minScore = form.score.min
        //     } else {
        //       params.minScoreContain = form.score.min
        //     }

        //     if (form.score.max === 0) {
        //       params.maxScore = form.score.max
        //     } else {
        //       params.maxScoreContain = form.score.max
        //     }
        //   }
        // }

        // 反馈状态
        // if (form?.feedbackStatus) params.feedbackStatus = Number(form.feedbackStatus)

        // 关键词
        // if (form?.keywords) params.contents = [form.keywords]
        // if (form.commentType === 'positive') {
        //   params.minScoreContain = form.score.min
        //   params.maxScoreContain = form.score.max
        // } else if (form.commentType === 'neutral') {
        //   params.minScoreContain = form.score.min
        //   params.maxScore = form.score.max
        // } else if (form.commentType === 'bad') {
        //   params.minScore = form.score.min
        //   params.maxScore = form.score.max
        // } else {
        //   params.minScoreContain = form.score.min
        //   params.maxScoreContain = form.score.max
        // }

        // const commentChannelDatas = ChannelConfig.allChannelList.filter(item =>
        //   form.channel?.split(',').includes(item.CommentListPageConfig.formSearchValue)
        // )
        // if (commentChannelDatas.length > 0) params.channels = commentChannelDatas.map(item => item.value)

        // 竞对酒店并且是全部的时候，传全部渠道
        // if (!state.isSelf && !params.channels) {
        //   const values = state.channelConfig.channelList.map(item => item.formSearchValue)
        //   params['channels'] = ChannelConfig.allChannelList
        //     .filter(item => values.includes(item.CommentListPageConfig.formSearchValue))
        //     .map(item => item.value)
        // }
        // 竞对酒店传竞对酒店id
        if (!state.isSelf) {
          params.hotelIds = filter?.hotelInfo?.value
          params['competeHotelId'] =
            state?.currentCompetitor === 'all_area'
              ? state.competitorList
                  .filter(item => item.hotelType === 'area')
                  .map(item => item.hotelId)
                  .join(',')
              : state.currentCompetitor
        }

        // if (form.replyStatus === 'replied') {
        //   params.isReply = 1
        // } else if (form.replyStatus === 'noReply') {
        //   params.isReply = 0
        // } else if (form.replyStatus === 'lateReply') {
        //   params.isReply = 3
        // } else if (form.replyStatus === 'noLateReply') {
        //   params.isReply = 4
        // }
        // if (form.commentSpecial === 'homeCriticism') {
        //   params.feature = 1
        // } else if (form.commentSpecial === 'moreNegative') {
        //   params.feature = 2
        // }
        // const biCommentId = router.currentRoute?.query?.biCommentId
        // if (biCommentId) params['ids'] = [biCommentId]
        params.hotelFilter = {
          tagList: {},
          hotelIdList: [filter?.hotelInfo?.value],
        }

        // 指标树-观点类型
        const labelSentimentLevel = state.treeSentimentLevel
        if (labelSentimentLevel) {
          params['labelSentimentLevel'] = labelSentimentLevel
        }

        if (payload.isGroup) {
          delete params.hotelFilter
          //  delete params.competeHotelId
          delete params.hotelIds
          delete params.hotelId
        }
        const res = await CommentAnalysisService.listCommentLabelsTree(params)
        if (res?.data && res?.code === 200) {
          const data = { ...res.data, raws: res.data.raws }
          // if (state.department.departmentLables?.length) {
          //   data.raws = getSameIndicators(data.raws, state.department.departmentLables)
          // }
          data.raws = commentTreeFormatter(data.raws)
          let tt = 0
          for (let i = 0; i < data.raws.length; i++) {
            tt += Number(data.raws[i].total)
          }
          data.raws.unshift({
            labelId: 'label_1',
            labelName: $t('f9b741'),
            labelNameEn: 'All',
            total: tt,
            uniqueId: $t('f9b741'),
          })

          commit('SET_COMMENT_LABELS_TREE', data)

          if (!state.commentLabelsTree.selectedTree.length) {
            commit('SET_COMMENT_LABELS_TREE', { selectedTree: [{ label_1: $t('f9b741') }] })
          }
        }

        if (res.code === 400) {
          commit('SET_SEARCH_FORM', { department: undefined })
          commit('SET_COMMENT_LABELS_TREE', {
            labelMap: {},
            raws: [],
          })
        }
      } catch (error) {
        console.error(error)
      }
      commit('SET_COMMENT_LABELS_TREE', { loading: false })
    },
    // 更新指标树数据
    updateTreeData({ rootState, state, commit }, payload = {}) {
      try {
        commit('SET_COMMENT_LABELS_TREE', { loading: true })
        const treeData = VocDeepClone.deepClone(state.initLabelsTree)
        let { raws = [] } = treeData
        if (state.department.departmentLables?.length) {
          raws = getSameIndicators(raws, state.department.departmentLables)
        }
        raws = commentTreeFormatter(raws)
        commit('SET_COMMENT_LABELS_TREE', { ...treeData, raws })
      } catch (error) {
        console.error(error)
      }
      commit('SET_COMMENT_LABELS_TREE', { loading: false })
    },
    // 查询banner
    async fetchCommentBadTotal({ rootState, state, commit }, payload = {}) {
      try {
        // if (state.commentBadTotal.loading) {
        //   return
        // }
        const filter = rootState.common.dateFilter
        let startTs = filter?.dateRange ? filter.dateRange[0] : new Date()
        startTs.setMilliseconds(0)
        startTs = startTs.getTime()
        let endTs = filter?.dateRange ? filter.dateRange[1] : new Date()
        endTs.setMilliseconds(999)
        endTs = endTs.getTime()

        const hotelId = rootState.common.dateFilter.hotelInfo?.hotelInfo.ctripHotelId
        commit('SET_COMMENT_BAD_TOTAL', { loading: true })
        const res = await CommentListService.getCommentBadTotal({
          ...payload,
          startTs,
          endTs,
          hotelId,
          treeName: 'hotel_rujia_code_model',
        })
        if (res?.data && res?.code === 200) {
          commit('SET_COMMENT_BAD_TOTAL', res.data)
        }
      } catch (error) {
        console.error(error)
      }
      commit('SET_COMMENT_BAD_TOTAL', { loading: false })
    },
    // 检查回复打标情况
    async replyCommentConfirm(_, payload) {
      try {
        const res = await CommentListService.getCommentTextCodes({ text: payload.content })
        if (res?.data && res?.code === 200) {
          return res.data.analyse || []
        }
      } catch (error) {
        console.error(error)
      }
      return false
    },
    // 可批量回复
    async batchReply({ commit, rootState, state }, payload = {}) {
      try {
        commit('SET_BATCH_REPLY', { loading: true })
        const hotelId = rootState.common.dateFilter?.hotelInfo?.value
        const { replyList = [], content } = payload
        const trip = []
        const qunaer = []
        const elong = []
        const baidawu = []
        const yifen = []
        const rujia = []
        const trip_params = []
        const qunaer_params = []
        const elong_params = []
        const baidawu_params = []
        const yifen_params = []
        const rujia_params = []

        // let keyMap = {
        //   ctrip: 'trip',
        //   elong: 'elong',
        //   qunar: 'qunaer',
        //   delonix: 'delonix',
        //   rujia: 'rujia',
        //   yifen: 'yifen',
        // }

        // let channelMap = {}

        for (const item of replyList) {
          // let name = keyMap[item.channel__en]
          // if (channelMap[name]) {
          //   channelMap[name].push(_item)
          // } else {
          //   channelMap[name] = [_item]
          // }
          item.channel = item.channel || item.channel__en
          if (['ctrip', $t('e3f92d')].includes(item.channel)) {
            trip.push(item.dataCid)
            trip_params.push({
              dataCid: item.dataCid,
              detailCommentId: item.detailCommentId,
            })
          } else if (['elong', $t('df1df6')].includes(item.channel)) {
            elong.push(item.dataCid)
            elong_params.push({
              dataCid: item.dataCid,
              detailCommentId: item.detailCommentId,
            })
          } else if (['qunar', $t('13611a')].includes(item.channel)) {
            qunaer.push(item.dataCid)
            qunaer_params.push({
              dataCid: item.dataCid,
              detailCommentId: item.detailCommentId,
            })
          } else if (['delonix', $t('d4478c')].includes(item.channel)) {
            baidawu.push(item.dataCid)
            baidawu_params.push({
              dataCid: item.dataCid,
              detailCommentId: item.detailCommentId,
            })
          } else if (['rujia', $t('b8ee0c')].includes(item.channel)) {
            rujia.push(item.dataCid)
            rujia_params.push({
              dataCid: item.dataCid,
              detailCommentId: item.detailCommentId,
            })
          } else if ([$t('44f60c'), 'yifen'].includes(item.channel)) {
            yifen.push(item.dataCid)
            yifen_params.push({
              dataCid: item.dataCid,
              detailCommentId: item.detailCommentId,
            })
          }
        }
        let param = {
          hotelId,
          replyContent: content,
          channelMap: {
            trip: trip_params.length ? trip_params : undefined,
            qunaer: qunaer_params.length ? qunaer_params : undefined,
            elong: elong_params.length ? elong_params : undefined,
            delonix: baidawu_params.length ? baidawu_params : undefined,
            rujia: rujia_params.length ? rujia_params : undefined,
            yifen: yifen_params.length ? yifen_params : undefined,
          },
          // channelMap,
        }

        if (payload.isGroup) {
          param.deptUid = payload.deptUid
        }
        if (payload.analysisTaskId) {
          param.analysisTaskId = payload.analysisTaskId
        }

        const res = await CommentListService.batchReplyComment(param)
        if (res?.data && res?.code === 200) {
          let objkey = Object.keys(res.data)
          if (objkey.length && res.data[objkey[0]]?.failStatus === 1 && res.data[objkey[0]]?.failMsg) {
            return {
              status: 'REPLY_FAIL',
              failMsg: res.data[objkey[0]]?.failMsg,
            }
          }

          commit('UPDATE_COMMENT_RAW_DATA', {
            dataCidList: [...trip, ...qunaer, ...elong, ...baidawu, ...rujia, ...yifen],
            replyContent: content,
          })

          commit('SET_BATCH_REPLY', { opened: false })
          commit('SET_REPLY_DIALOG', { opened: false })
          // 对列表的状态回复状态进行更新

          let rowData = state.commentRawData?.rowData.map(item => {
            for (let i in res.data) {
              // 如家、逸粉回复状态延迟 如果不为0的话 页面会展示 暂无回复
              let isRujiaOrYifen = ['rujia', 'yifen', $t('b8ee0c'), $t('44f60c')].includes(item.channel)
              if (i === item.detailCommentId) {
                item.isReply = isRujiaOrYifen ? 0 : res.data[i].replyStatus
                // item.isFeedBack = res.data[i].replyStatus
              }
            }
            return item
          })

          commit('SET_COMMENT_RAW_DATA', { rowData, sentencesHighlight: state.sentencesHighlight })

          return { status: 'success' }
        } else if (res?.msgCode === 'REPLY_LIMIT' || res?.msgcode === 'REPLY_LIMIT') {
          return { status: 'REPLY_LIMIT' }
        } else if (res?.msgCode === 'GENERAL_ERROR_ALERT' || res?.msgcode === 'GENERAL_ERROR_ALERT') {
          return { status: 'GENERAL_ERROR_ALERT' }
        }
      } catch (error) {
        console.error(error)
      } finally {
        commit('SET_BATCH_REPLY', { loading: false })
      }
      return { status: 'error' }
    },
    // AI回复模版-h5
    async openAIReplyDialog({ rootState, state, commit }, { opened = true, originContent, requestId, cancelAxios }) {
      // 加载模板列表
      let replyTemplateList = [],
        loading = false

      try {
        // if (loading) {
        //   return
        // }
        loading = true
        commit('SET_AI_REPLY', { loading, opened, selectedTemplate: undefined })

        if (opened) {
          const res = await CommentListService.listAIReplyTemplate(
            {
              commentContent: originContent,
              requestId,
            },
            cancelAxios
          )
          if (res?.data && res?.code === 200) {
            replyTemplateList = res.data.filter(item => item?.content)
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        if (replyTemplateList?.length > 0) loading = false
      }

      commit('SET_AI_REPLY', { replyTemplateList, loading })
    },
    async getAIReplyTranslate(
      { state, commit },
      { getTaskId = false, originContent, styleCode, cancelAxios, AIReplyItem }
    ) {
      let loading = 'loading'
      let translateResult = ''
      commit('SET_AI_REPLY', { opened: true, translateStatus: loading, translateResult: '' })
      try {
        let translateTaskId = state.AIReplyDialog.translateTaskId
        if (getTaskId || !translateTaskId) {
          const params = {
            content: originContent,
            toBeTranslatedContent: AIReplyItem.content,
          }
          const res = await CommentListService.AIReplyGetTranslateTaskId(params)
          if (!res.successful || !res.data?.taskId) {
            Message.error(res.message)
            return commit('SET_AI_REPLY', { translateStatus: 'fail', translateResult: '' })
          }
          translateTaskId = res.data.taskId
          commit('SET_AI_REPLY', { translateTaskId })
        }
        const res = await CommentListService.listAIReplyGetTemplate(
          {
            analysisTaskId: translateTaskId,
          },
          cancelAxios
        )
        if (res?.successful) {
          if (res.data.analysisStatus === 0) {
            return commit('SET_AI_REPLY', { translateStatus: loading, translateResult: '' })
          }
          if (res.data.analysisStatus === 1) {
            loading = 'done'
            translateResult = res.data.analysisResult
            const cachedInfo = state.AIReplyDialog.cachedInfo
            const replyTemplateList = [
              {
                ...AIReplyItem,
                preContent: AIReplyItem.content,
              },
            ]
            commit('SET_AI_REPLY', {
              replyTemplateList: replyTemplateList,
              cachedInfo: {
                ...cachedInfo,
                [styleCode]: {
                  replyTemplateList,
                  translateTaskId,
                  translateResult,
                  translateStatus: 'done',
                },
              },
            })
          }
          if (res.data.analysisStatus === -1) {
            Message.error($t('4609c8'))
            loading = 'fail'
          }
        } else {
          Message.error(res.message)
          loading = 'fail'
        }
      } catch (error) {
        console.error(error)
      } finally {
        if (translateResult) {
          loading = 'done'
        }
      }
      commit('SET_AI_REPLY', { translateStatus: loading, translateResult })
    },
    async openAIReplyDialogWidthLog(
      { rootState, state, commit },
      { getTaskId = false, retry = false, opened = true, running = false, styleCode, cancelAxios }
    ) {
      // 加载模板列表
      let replyTemplateList = [],
        loading = false

      try {
        if (!opened) {
          running = false
        }
        commit('SET_AI_REPLY', { opened, running, selectedTemplate: undefined })

        if (running) {
          loading = true
          commit('SET_AI_REPLY', { loading })
          let analysisTaskId = state.AIReplyDialog.analysisTaskId
          if (getTaskId) {
            analysisTaskId = undefined
          }
          if (!analysisTaskId) {
            const dataItem = state.AIReplyDialog.dataItem
            const { qualityMap } = dataItem
            if (!qualityMap?.hotelId) {
              Message.error($t('6d7142'))
              return commit('SET_AI_REPLY', { replyTemplateList, loading: false, analysisTaskId })
            }
            const params = {
              styleCode: styleCode,
              commentId: dataItem.detailCommentId,
              fullHotelId: qualityMap?.hotelId,
            }
            const res = await CommentListService.AIReplyGetTaskId(params, cancelAxios)
            if (!res.successful || !res.data?.taskId) {
              Message.error(res.message)
              return commit('SET_AI_REPLY', { replyTemplateList, loading: false, analysisTaskId })
            }
            analysisTaskId = res.data.taskId
            commit('SET_AI_REPLY', { analysisTaskId })
          } else if (retry) {
            const params = {
              analysisTaskId,
            }
            const res = await CommentListService.listAIReplyRetry(params, cancelAxios)
            if (!res.successful || !res.data?.analysisTaskId) {
              Message.error(res.message)
              return commit('SET_AI_REPLY', { replyTemplateList, loading: false })
            }
            analysisTaskId = res.data.analysisTaskId
            commit('SET_AI_REPLY', { analysisTaskId })
          }

          const res = await CommentListService.listAIReplyGetTemplate(
            {
              analysisTaskId,
            },
            cancelAxios
          )
          if (res?.successful) {
            if (res.data.analysisStatus === 0) {
              return commit('SET_AI_REPLY', { replyTemplateList, loading })
            }
            loading = false
            if (res.data.analysisStatus === 1) {
              replyTemplateList = [{ content: res.data.analysisResult }].map(item => ({
                ...item,
                feedbackType: '',
                feedbackReason: '',
                optionRecordId: undefined,
                canOperate: true,
                preContent: item.content, // 用于对比内容变化
              }))
            }
            if (res.data.analysisStatus === -1) {
              Message.error($t('c9fead'))
            }
          } else {
            Message.error(res.message)
            loading = false
          }
        } else {
          const cachedInfo = state.AIReplyDialog.cachedInfo
          if (cachedInfo[styleCode]) {
            replyTemplateList = cachedInfo[styleCode].replyTemplateList
            loading = false
            commit('SET_AI_REPLY', {
              running: true,
              analysisTaskId: cachedInfo[styleCode].analysisTaskId,
              translateResult: cachedInfo[styleCode].translateResult,
              translateStatus: cachedInfo[styleCode].translateStatus,
              translateTaskId: cachedInfo[styleCode].translateTaskId,
            })
          } else {
            commit('SET_AI_REPLY', {
              translateResult: '',
              translateStatus: undefined,
              translateTaskId: '',
            })
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        if (replyTemplateList?.length > 0 && running) {
          loading = false
          commit('SET_AI_REPLY', {
            cachedInfo: {
              ...state.AIReplyDialog.cachedInfo,
              [styleCode]: {
                replyTemplateList,
                analysisTaskId: state.AIReplyDialog.analysisTaskId,
                translateTaskId: undefined,
                translateResult: '',
                translateStatus: '',
              },
            },
            translateTaskId: undefined,
            translateResult: '',
            translateStatus: '',
          })
        }
      }
      commit('SET_AI_REPLY', {
        replyTemplateList,
        loading,
      })
    },
    // 打开模板 fetchReplyTemplateList
    async openReplyDialog({ rootState, state, commit }, { openType, opened = true, canEdit = undefined }) {
      // 加载模板列表
      if (canEdit === undefined) {
        canEdit = state.replyDialog.canEdit
      }
      let replyTemplateList = [],
        loading = false,
        type = openType || state.replyDialog.type

      try {
        if (loading) {
          return
        }
        loading = true
        commit('SET_REPLY_DIALOG', { loading, opened, type, selectedTemplate: undefined })

        const hotelId = rootState.common.dateFilter.hotelInfo?.value
        const res = await CommentListService.listReplyTemplate({
          hotelId,
          pageNo: state.replyDialog.page.current,
          pageSize: 50, // state.replyDialog.page.pageSize,
        })
        if (res?.data && res?.code === 200) {
          replyTemplateList = res.data.records.map(item => {
            return {
              ...item,
              isReadonly: true,
            }
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        loading = false
      }

      commit('SET_REPLY_DIALOG', { replyTemplateList, loading, canEdit })
    },
    // 删除模板
    async deleteReplyTemplate({ state, commit }) {
      try {
        const templateItem = state.replyTemplateDeleteConfirmDialog.selectItem
        if (!templateItem) {
          return false
        }
        const res = await CommentListService.delReplyTemplate({ templateId: templateItem.uid })
        if (res?.data && res?.code === 200) {
          commit('SET_DELETE_CONFIRM_DIALOG', { opened: false, selectItem: undefined })
          const replyTemplateList = state.replyDialog.replyTemplateList
          const index = replyTemplateList.findIndex(item => item.uid === templateItem.uid)
          replyTemplateList.splice(index, 1)
          commit('SET_REPLY_DIALOG', { replyTemplateList })
          return true
        }
      } catch (error) {
        console.error(error)
      }
      return false
    },
    // 添加模板
    async addReplyTemplate({ rootState, state, commit }, payload) {
      try {
        const hotelId = rootState.common.dateFilter.hotelInfo?.value
        const countRes = await CommentListService.getReplyTemplateCount({ hotelId })
        if (countRes?.data && countRes?.code === 200) {
          if (countRes.data > 9) {
            return {
              type: 'error',
              message: $t('1b5048'),
            }
          }
        }
        const res = await CommentListService.addReplyTemplate({ hotelId, content: payload.content })
        if (res?.data && res?.code === 200) {
          const replyTemplateList = state.replyDialog.replyTemplateList
          replyTemplateList.push(res.data)
          commit('SET_REPLY_DIALOG', { replyTemplateList })
          return {
            type: 'success',
            message: $t('0e8a31'),
          }
        }
      } catch (error) {
        console.error(error)
      }
      return {
        type: 'error',
        message: $t('e62033'),
      }
    },
    // 点评列表查询点评数量
    async fetchComplaintCommentCount({ rootState, state, commit }, payload) {
      try {
        const dateFilter = rootState.common.dateFilter
        let list = payload instanceof Array ? payload : []
        const commentIds = list.filter(item => item.sentimentLevel === $t('40c733')).map(item => item.detailCommentId)
        if (commentIds?.length === 0) {
          return
        }

        const res = await CommentListService.fetchComplaintCommentCount({
          hotelId: dateFilter?.hotelInfo?.value,
          commentIds: commentIds,
        })
        if (res?.data && res?.code === 200) {
          // 保留之前拿到的客诉追踪结果
          const current = state.commentRawData.current || 1
          const commentIdComplaint = state.commentIdComplaint || {}
          const newCommentIdComplaint = current === 1 ? res.data : { ...commentIdComplaint, ...res.data }
          commit('SET_COMMENTIDCOMPLAINT', newCommentIdComplaint)
        }

        if (res.code === 400) {
          commit('SET_COMMENTIDCOMPLAINT', {})
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 加载工单mapping关系
    async fetchWorkOrderMapping({ state, commit }) {
      const params = {
        attributeKey: 'comment_data_row_id',
        attributeValues: [],
      }
      const commentList = state.commentRawData.rowData
      const workOrderMappping = state.workOrderMappping
      if (commentList?.length) {
        for (const item of commentList) {
          if (!workOrderMappping[item.detailCommentId]) {
            params.attributeValues.push(item.detailCommentId)
          }
        }
      }
      if (params.attributeValues.length > 0) {
        const res = await MAPI_SERVICE_ACTION_RECORD.getCommentWorkflowList(params) //await CommentListService.listWorkOrder(params)

        if (Object.keys(res).length) {
          commit('SET_WORKER_ORDER_MAPPING', res)
        }
      }
    },
    // 创建工单
    createRepairOrder(_, payload) {
      const newTag = `<div style="white-space: break-spaces;">${payload.detail.value}</div>`
      workorderSession.set(payload.rowId, {
        content: newTag,
        title: payload.channel + $t('355656'),
        sourceChannel: 8,
        data_row_id: payload.detailCommentId,
      })
      const state = _.rootGetters.deviceMode

      const url =
        state === 'mobile'
          ? `${process.env.VUE_APP_CDN_DOMAIN}/workflow/m/work-order/create`
          : `${process.env.VUE_APP_CDN_DOMAIN}/workflow/all-work-order/create`
      window.open(`${url}?id=${payload.rowId}&sourceType=3`, '_self')
    },
    // 获取渠道配置
    async getChannelConfig({ rootState, state, commit }, payload = {}) {
      try {
        const form = state.searchForm
        const hotelId = payload.isGroup ? '' : rootState.common.dateFilter.hotelInfo?.value
        const res = await CommentAnalysisService.paramsQuery({ hotelId, ...payload })
        if (res?.data && res.code === 200) {
          const allChannelList = ChannelConfig.allChannelList.sort((a, b) => a.order - b.order)
          const data = allChannelList
            .filter(item => res.data[item.configValue])
            .map(item => {
              return {
                ...item.CommentListPageConfig,
                isChannelSelected: !form?.channel
                  ? false
                  : form?.channel?.includes(item.CommentListPageConfig.formSearchValue),
                // isChannelSelected: false,
              }
            })

          commit('SET_CHANNEL_CONFIG', { channelList: data })
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 纠错
    async addErrorCorrection({ state, commit }, payload) {
      try {
        if (state.errorCorrection.loading) {
          return
        }

        commit('SET_ERROR_CORRECTION', { loading: true })
        const rowItem = state.errorCorrection.rowDataItem

        let date = dayjs(rowItem.commentDate.replace(' ', 'T').replace(/(\+)(\d{2})(\d{2})/, '$1$2:$3')).toDate()
        if (String(date) === 'Invalid Date') {
          date = dayjs(rowItem.commentDate.replace(/(\+)(\d{2})(\d{2})/, '$1$2:$3')).toDate()
        }

        const commentDate = date
        let source
        ChannelConfig.allChannelList.map(item => {
          if (item.value === rowItem.qualityMap.channel) {
            source = item.configValue
          }
        })

        // const codes = uniqBy(rowItem.detail.codes, n =>
        //   Object.keys(n.labelMap)
        //     .map((value, i) => n.labelMap[`label${i + 1}`])
        //     .join(' /')
        // )

        // const codes = rowItem.detail.codes.map(n => {
        //   n.labelMap = Object.keys(n.labelMap)
        //     .map((value, i) => n.labelMap[`label${i + 1}`])
        //     .reduce((initValue, value, i) => {
        //       initValue[`label${i + 1}`] = value
        //       return initValue
        //     }, {})

        //   return {
        //     ...n,
        //   }
        // })

        // const codes = uniqBy(rowItem.detail.codes, n => `${n.label} /${n.label2} / ${n.label3} / ${n.label4}`)

        const params = {
          commentDate: commentDate.getTime(), // `评论时间`
          content: rowItem.detail.value, // `评论内容`
          dataCid: rowItem.dataCid, // `点评id`
          // hotelId: rootGetters.dateFilter.hotelInfo.value, // `酒店id`
          hotelId: rowItem.qualityMap.hotelId, // `酒店id`
          source: source, // `评论来源  1:美团2:携程3:飞猪4:艺龙`
          // treeName: 'hotel_rujia_code_model',
          score: rowItem.score,
          sentiment: rowItem.sentimentValue,
          sentimentLevel: rowItem.sentimentLevel,
          detailCommentId: rowItem.detailCommentId,
          // labelPortraitList: rowItem.labelPortrait,
          ...payload,
        }

        const res = await CommentListService.qualityCreate(params)
        if (res?.code === 200 && res?.data) {
          Message.success($t('c82fae'))
          return true
        }
        Message.error($t('eb9c9f'))
        return false
      } catch (error) {
        console.error(error)
        Message.error($t('eb9c9f'))
        return false
      } finally {
        commit('SET_ERROR_CORRECTION', { loading: false })
      }
    },
    // 客诉追踪
    async mapToVoiceTagList({ commit }, payload) {
      try {
        const res = await CommentListService.listByPoint(payload)
        if (res?.code === 200 && res?.data?.length) {
          return res.data.map(item => {
            // dynamic indicators-voice
            const label = item.labelMap

            // if (item.label1) {
            //   label.firstLabel = item.label1
            // }
            // if (item.label2) {
            //   label.twoLabel = item.label2
            // }
            // if (item.label3) {
            //   label.threeLabel = item.label3
            // }
            return label
          })
        }
        return []
      } catch (error) {
        console.error(error)
        return []
      }
    },
    // 获取竞对列表
    async getCompetitorList({ commit, rootState, state }, payload = {}) {
      try {
        // let singleHotelInfo = {}
        // if (state?.urlHotel) {
        //   const resList2 = await AuthService.getHotelList({
        //     hotelNameSearch: '',
        //     pageNo: 1,
        //     pageSize: 1,
        //     hotelIdList: [router.currentRoute.query?.hotelId],
        //   })
        //   if (resList2.data?.records?.length > 0) {
        //     singleHotelInfo = {
        //       hotelInfo: {
        //         hotelInfo: resList2.data.records.map(item => {
        //           return {
        //             label: item.hotelName,
        //             value: item.hotelId,
        //             ...item,
        //           }
        //         })[0],
        //       },
        //       urlHotelId: state?.urlCommentHotelMap?.urlHotelId,
        //     }
        //     state.urlCommentHotelMap = singleHotelInfo
        //   }
        // }

        if (router.currentRoute.query?.competeHotelId)
          state.currentCompetitor = router.currentRoute.query?.competeHotelId

        const filter = rootState.common.dateFilter
        let startTs = filter?.dateRange ? filter.dateRange[0] : new Date()
        // startTs.setMilliseconds(0)
        startTs = new Date(dayjs(startTs).format('YYYY/MM/DD') + ' 00:00:00').getTime()
        let endTs = filter?.dateRange ? filter.dateRange[1] : new Date()
        // endTs.setMilliseconds(999)
        endTs = new Date(dayjs(endTs).format('YYYY/MM/DD') + ' 23:59:59').getTime()
        // const ctripHotelId = singleHotelInfo?.hotelInfo?.hotelInfo?.ctripHotelId
        // const ctripHotelName = singleHotelInfo?.hotelInfo?.hotelInfo?.ctripHotelName
        const params = {
          ...payload,
          startTs,
          endTs,
          hkHotelId: filter?.hotelInfo?.hotelInfo?.ctripHotelId,
          hkHotelName: filter?.hotelInfo?.hotelInfo?.ctripHotelName,
          // hkHotelId: ctripHotelId ? ctripHotelId : filter?.hotelInfo?.hotelInfo?.ctripHotelId,
          // hkHotelName: ctripHotelName ? ctripHotelName : filter?.hotelInfo?.hotelInfo?.ctripHotelName,
        }

        // 跳转到点评管理 url上带有hotelId
        // const hotelMap = state?.urlCommentHotelMap?.hotelInfo?.hotelInfo
        // if (state?.urlCommentHotelMap?.urlHotelId) {
        //   params.hkHotelId = hotelMap.ctripHotelId
        //   params.hkHotelName = hotelMap.ctripHotelName
        // }

        const res = await CommentAnalysisService.getCompetitorCommentCount(params)
        if (res?.data && res.code === 200) {
          let sort = 0
          res.data = res.data
            .map((item, i) => {
              if (item.hotelType === 'main') {
                sort = 0
              } else if (item.hotelType === 'all_area') {
                sort = 1
                item.hotelId = 'all_area'
              } else {
                sort = i + 1
              }

              return {
                ...item,
                sort,
              }
            })
            .sort((a, b) => a.sort - b.sort)

          commit('SET_COMPETITOR_LIST', res.data)
        } else {
          commit('SET_COMPETITOR_LIST', [])
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 查询是否可以设置会员卡号
    async getVIPCardNoPermission({ commit }) {
      try {
        const res = await CommentListService.fetchVIPCardPermission()
        if (res?.data && res.code === 200) {
          commit('SET_VIP_CARD_PERMISSION', res.data)
        } else {
          commit('SET_VIP_CARD_PERMISSION', false)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 获取会员卡号信息列表
    async getVIPCardNoMap({ state, commit, rootState }, payload = {}) {
      try {
        let params = [],
          commentCardObj = {}
        if (Object.keys(payload || {}).length > 0) {
          const map = ChannelConfig.allChannelList.reduce((channel, item) => {
            channel[item.value] = item.configValue
            return channel
          }, {})

          payload.map(item => {
            params.push({
              hotelId: item.hotelId || rootState.common.dateFilter?.hotelInfo?.hotelInfo?.ctripHotelId, // group的时候前者有，单店的时候前者没有后者有
              dataCid: item.dataCid,
              source: map[item?.qualityMap?.channel],
            })
            commentCardObj[item.dataCid] = undefined
          })
        }

        const isNullArray = params.filter(item => !!item?.dataCid)
        if (isNullArray.length === 0) return

        commit('SET_VIP_CARD_MAP', commentCardObj)

        const res = await CommentListService.fetchVIPCardNoList({ commentList: params })
        if (res?.data && res.code === 200) {
          const newCardMap = {}
          Object.keys(state.vipCardNoMap).map(value => {
            const cardList = res.data.filter(item => item.commentId === value)
            const val = cardList.length > 0 ? cardList[0].userInfoId : ''
            newCardMap[value] = {
              showBindPopup: false,
              cardNo: val,
              asliasCardNo: val,
            }
          })
          commit('SET_VIP_CARD_MAP', newCardMap)
        } else {
          commit('SET_VIP_CARD_MAP', {})
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 保存会员卡号
    async saveVIPCardNoData({ state, commit, rootState }, payload = {}) {
      try {
        let source = ''
        const commentChannelDatas = ChannelConfig.allChannelList.filter(
          item => item.value === payload?.dataItem?.qualityMap.channel
        )
        if (commentChannelDatas.length > 0) source = commentChannelDatas[0].CommentAnalysisConfig.channel

        const res = await CommentListService.saveVIPCardNo({
          userInfoId: payload.cardNo,
          commentId: payload.dataCid,
          source: source,
          hotelId: rootState.common.dateFilter?.hotelInfo?.hotelInfo?.ctripHotelId,
        })
        if (res?.data && res.code === 200) {
          Message.success($t('465d73'))
          state.vipCardNoMap[payload.dataCid].asliasCardNo = payload.cardNo
          commit('SET_VIP_CARD_MAP', state.vipCardNoMap)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 获取最新数据同步时间
    async getLeastDataTime({ rootState, state, commit }, payload = {}) {
      try {
        const form = state.searchForm
        const filter = rootState.common.dateFilter
        const hotelId = filter?.hotelInfo?.hotelInfo?.ctripHotelId
        let params = {
          hotelId: hotelId,
        }

        let channels = []
        const commentChannelDatas = ChannelConfig.allChannelList.filter(item =>
          form.channel?.split(',').includes(item.CommentListPageConfig.formSearchValue)
        )
        if (commentChannelDatas.length > 0) channels = commentChannelDatas.map(item => item.value)

        if (channels.length === 1) {
          params.channel = channels[0]
          const res = await CommentAnalysisService.getLeastDataTime(params)
          if (res?.data && res?.code === 200) {
            const data = res.data
            commit('SET_COMMENT_DATA_SYNC_TIME', JSON.stringify(data) === '{}' ? '' : data)
          } else {
            commit('SET_COMMENT_DATA_SYNC_TIME', '')
          }
        } else {
          commit('SET_COMMENT_DATA_SYNC_TIME', '')
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 加载回复状态
    async loadReplyStatus({ rootState, state, commit }, payload = {}) {
      try {
        // 竞对酒店不要逾期
        if (!state.isSelf) {
          commit('SET_SEARCH_FORM', { replyStatus: state.searchForm.replyStatus })
          commit('SET_COMMENT_REPLY_STATUS', [])
        } else {
          const filter = payload.filter || rootState.common.dateFilter
          const hotelId = filter?.hotelInfo?.value
          let params = {
            ...payload,
            hotelId,
          }

          const res = await CommentAnalysisService.fetchIsLate(params)
          if (res?.code === 200) {
            const { channelIds } = res.data
            const datas = ChannelConfig.allChannelList
              .filter(item => channelIds.includes(item.configValue))
              .map(item => item.CommentListPageConfig.formSearchValue)
            commit('SET_COMMENT_REPLY_STATUS', datas)
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 加载点评类型-情感/分数
    async loadCommentRuleType({ rootState, state, commit }, payload = {}) {
      try {
        const filter = payload.filter || rootState.common.dateFilter
        const hotelId = filter?.hotelInfo?.value || filter?.hotelInfo?.hotelInfo?.hotelId
        let params = {
          hotelId,
          ...payload,
        }
        const res = await AssessmentIndicatorsService.fetchDetail(params)
        if (res?.code === 200) {
          // if (Number(res?.data?.ruleType) === 1) {
          //   commit('SET_SEARCH_FORM', { score: { min: undefined, max: undefined } })
          // }
          // 按分数划分
          if (Number(res?.data?.ruleType) === 2) {
            commit('SET_COMMENT_RULE_MAP', {
              score: res.data?.scoreSectionConfig,
            })
          }
          commit('SET_COMMENT_RULE_TYPE', Number(res?.data?.ruleType) === 1)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 是否质检
    async getIsQuality({ rootState, state, commit }, payload = {}) {
      try {
        const form = state.searchForm
        const filter = rootState.common.dateFilter
        const hotelId = filter?.hotelInfo?.hotelInfo?.ctripHotelId
        let params = {
          hotelIds: hotelId,
          data: payload.rowData.map(item => {
            return {
              otaCommentId: item.qualityMap.commentId, //# 点评ID
              source: form.channel, //# 渠道
            }
          }),
        }

        const res = await CommentListService.fetchIsQuality(params)
        if (res?.data && res?.code === 200) {
          const data = res.data
          if (data.length > 0) {
            payload.rowData.map(item => {
              const list = data.filter(subItem => subItem.otaCommentId === item?.qualityMap?.commentId)
              item.isQuality = list.length > 0 ? list[0].isQuality : 0
            })
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 反馈记录数据
    async listFeedbackRecord({ rootState, state, commit }, payload = {}) {
      try {
        let params = {
          hotelId: payload.hotelId,
          otaCommentId: payload.commentId, //# 点评ID
          source: payload.channel, //# 渠道
        }
        const res = await CommentListService.fetchcommentQualityList(params)

        if (res?.data && res?.code === 200) {
          const data = res.data
          commit(
            'SET_FEEDBACK_RECORD_MAP',
            data.map(item => {
              return {
                feedbackTime: item.pushTime,
                feedbackReason: item.errorTypes,
                additionalInstructions: item.remark,
                processingState: item.dealStatus, // 处理中  已出理
                processingTime: item.qualityTime,
                processingResults: item.dealResult,
                processingNote: item.dealRemark,
                ...item,
              }
            })
          )
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 撤销反馈记录
    async cancelFeedback({ rootState, state, commit }, payload = {}) {
      try {
        let params = {
          hotelId: payload.hotelId,
          commentId: payload.commentId,
          qualityId: payload.qualityId,
        }
        return await CommentListService.cancelFeedback(params)
      } catch (error) {
        console.error(error)
      }
    },
    // 保存模版信息
    async fetchEditorReplyTemplate({ rootState, state }, payload = {}) {
      try {
        let uid = payload?.uid
        if (!uid) {
          const hotelId = rootState.common.dateFilter.hotelInfo?.value
          const res = await CommentListService.addReplyTemplate({ hotelId, content: payload.content })
          uid = res?.data?.uid
        }

        let params = {
          content: payload.content,
          templateId: uid,
        }
        return await CommentListService.editorReplyTemplate(params)
      } catch (error) {
        console.error(error)
      }
    },
  },
}
